import { z } from "zod";
import AuthService from "../../../services/AuthService";
import { AxiosError, AxiosResponse } from "axios";
import { mapErrorsToFields } from "../../../utils";
import { IError } from "../../../core/HttpClient";

export type State = {
  errors?: {
    phone?: string[];    
    general?: string[];
  };
  success?: boolean;
  message?: IError | null;
  defaultValues?: {
    phone: string; 
    country: string;
    rememberMe: boolean;
  };
  data?: {verificationId:string};
};

const FormSchema = z.object({
  phone: z.string({
    error: "Phone number is required",
  }),
  country: z.string({
    error: "Country is required",
  })  ,
  rememberMe: z.boolean({
    error: "Remember me is required",
  })
});

export async function sendVerificationCode(
  prevState: State | undefined,
  data: FormData
): Promise<State> {
  const defaultValues = {
    phone: data.get("phone")?.toString() || "",
    country: data.get("country")?.toString() || "",
    rememberMe: data.get("rememberMe") === "on",
  };
  const cleanPhone = defaultValues.country.replace("+", "") + (defaultValues.phone.startsWith("0") ? defaultValues.phone.substring(1) : defaultValues.phone);  
  const result = FormSchema.safeParse(defaultValues);
  if (!result.success) {
    const errors = mapErrorsToFields(result.error);
    return { ...prevState, errors };
  }
  const api = new AuthService();
  try {
    const response: any = await api.sendVeruficationCode({
      phone: cleanPhone,      
    });
    const success = response.status === 200;
    console.log("Send verification code response:", response);
    if(success)
      return {
      ...prevState,
      defaultValues: {
        phone: cleanPhone,
        country: defaultValues.country,
        rememberMe: defaultValues.rememberMe,
      },
      message: null,
      success: success,
      data: response.data,
    };
    else
      return {
        ...prevState,
        defaultValues: defaultValues,
        message: {
          description: response.data.description,
          code: response.data.code,
        },
        success: false,
      };
    
  } catch (ex: AxiosError | any) {
    console.log("Login error:", ex.response?.data);
    return {
      ...prevState,
      defaultValues: defaultValues,
      message: {
        description: ex.response?.data.description || "Failed to send verification code.",
        code: ex.response?.data.code,
      },
      success: false,
    };
  }
  //- save token to local storage
}
 

